import { render } from "./CompareTableData.vue?vue&type=template&id=09905028&ts=true"
import script from "./CompareTableData.vue?vue&type=script&lang=ts"
export * from "./CompareTableData.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Build\\TCF\\ABBp_PIS\\6.15\\PisNextGenExtProd-PisApp_6_15_0\\PisNextGenExtProd\\PisNextGen\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__